import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import {
  ApiService,
  isSystemSuperAdminFromToken,
  Profile,
  ProfileService,
  StorageService,
  SYSTEM_SUPER_ADMIN_HOME,
} from '@app-utils';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import { AppLoaderService } from '../services';

export const profileGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const storageSvc = inject(StorageService);
  const apiSvc = inject(ApiService);
  const loaderSvc = inject(AppLoaderService);
  const profileSvc = inject(ProfileService);
  const token = storageSvc.getAuthToken();

  loaderSvc.setProfileLoader(true);
  const obs = (
    token
      ? apiSvc.getUserLoginDetail().pipe(
          map((res) => res.data),
          catchError((e) => {
            profileSvc.logout();
            void router.navigate(['/']);
            return throwError(e);
          }),
        )
      : of(null)
  ) as Observable<null | Profile>;
  return obs.pipe(
    tap((userRes) => {
      if (!userRes && !state.url.includes('/auth')) {
        loaderSvc.setProfileLoader(false);
        return void router.navigate(['auth']);
      }
      if (
        state.url.includes('/auth') &&
        userRes &&
        !state.url.includes('/auth/invitation') &&
        !state.url.includes('/auth/invite')
      ) {
        if (isSystemSuperAdminFromToken(storageSvc)) {
          return void router.navigateByUrl(SYSTEM_SUPER_ADMIN_HOME);
        }
        return void router.navigate(['/']);
      }

      if (
        userRes &&
        (state.url === '/' || state.url === '') &&
        isSystemSuperAdminFromToken(storageSvc)
      ) {
        return void router.navigateByUrl(SYSTEM_SUPER_ADMIN_HOME);
      }

      if (userRes) {
        profileSvc.setProfile(userRes);
      }
      if (userRes?.organisation?.length) {
        profileSvc.setOrganizationList(userRes?.organisation || []);
        // if (orgRes.length === 1 && !profileSvc.latestOrganization()) {
        //   profileSvc.setOrganization(orgRes[0]);
        //   void router.navigate(['org', orgRes[0].id]);
        // }
      }
      // token && setImage(userRes?.id || '').subscribe();
      loaderSvc.setProfileLoader(false);
    }),
    map((data) => !!data),
  );
};
